// Actions
const ACTION_TYPES = {
  SET_LOADING: "web-app-magmic-core/loading/SET_LOADING"
}

export const setLoading = (isLoading) => ({
  type: ACTION_TYPES.SET_LOADING,
  isLoading: isLoading
});

const initialState = {
  isLoading: false
};

// Reducers
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTION_TYPES.SET_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      };
    default:
      return state; // returned during app initialization
  }
}
